import React, { FC } from "react";
import { WTNScale } from "@clubspark/wtn-component-library";
import "./WTNWidget.scss";

interface Props {
  mode: "single" | "double";
  visible: boolean;
  wtnSingles?: null | number;
  wtnDoubles?: null | number;
  proPlayerSingles?: boolean;
  proPlayerDoubles?: boolean;
  confidenceSingles?: number;
  confidenceDoubles?: number;
  gameZoneLower?: number;
  gameZoneUpper?: number;
  infoIcon?: boolean;
}

const WTNWidget: FC<Props> = ({
  visible,
  wtnSingles,
  wtnDoubles,
  proPlayerSingles,
  proPlayerDoubles,
  confidenceSingles,
  confidenceDoubles,
  gameZoneLower,
  gameZoneUpper,
  infoIcon
}) => {
  return visible ? (
    <div className="WTN_widget">
      <WTNScale
        mode={"-"}
        wtnSingles={wtnSingles ? wtnSingles : 0}
        wtnDoubles={wtnDoubles ? wtnDoubles : 0}
        mobileBreakPoint={768}
        border={false}
        proPlayerSingles={proPlayerSingles}
        proPlayerDoubles={proPlayerDoubles}
        confidenceSingles={confidenceSingles}
        confidenceDoubles={confidenceDoubles}
        gameZoneLower={gameZoneLower}
        gameZoneUpper={gameZoneUpper}
        infoIcon={infoIcon}
      />
    </div>
  ) : null;
};

export default WTNWidget;
